import { client } from '@/sanity/lib/client';
import Bundle from '@/src/components/screens/Bundle/Bundle';

import { IFAQ } from '@/src/assets/interfaces/faqInterface';
import { faqQuery } from '@/src/assets/queries/faqQuery';
import themeArchiveQuery from '@/src/assets/queries/themeArchiveQuery';

import { ITheme } from '../../assets/interfaces/themeInterface/index';

type THomePageProps = {
    themesData: ITheme[];
    faqData: IFAQ[];
};

export default function HomePage({ themesData, faqData }: THomePageProps) {
    return <Bundle themesData={themesData} faqData={faqData} />;
}

export async function getStaticProps() {
    const themesData = await client.fetch(themeArchiveQuery);
    const faqData = await client.fetch(faqQuery);

    return {
        props: {
            themesData: themesData ?? null,
            faqData: faqData ?? null,
        },
        revalidate: 10,
    };
}
